// import styled from "styled-components";

// export const TransducerGoogleChirp1 = styled.div`
//   height: 100%;
//   box-sizing: border-box;
//   background-color: white;
//   border-top-left-radius: 20px;
//   border-top-right-radius: 20px;
//   width: 100%;
//   .transducer-content {
//     height: calc(100% - 81px);
//     padding: 20px 20px 0px 20px;
//     box-sizing: border-box;
//     display: flex;
//     flex-direction: column;
//     overflow: auto;
//     .transducer-choose-type {
//       height: 100%;
//       display: flex;
//       .transductor-mode {
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         margin-bottom: 10px;
//         &__label {
//           font-family: Nunito Sans Bold;
//           font-size: 20px;
//           margin-bottom: 10px;
//         }
//         &__selected {
//           width: 100%;
//           display: flex;
//           justify-content: center;
//         }
//       }
//       .message-space {
//         height: ${(modelsSelection) =>
//           !modelsSelection ? "calc(100% - 116px)" : "calc(100% - 232px)"};
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         justify-content: center;
//         margin: auto;
//         &__title {
//           font-family: Nunito Sans Bold;
//           font-size: 20px;
//           margin-bottom: 40px;
//         }
//         &__img {
//           &--medical-consultation {
//             width: 424.6px;
//             height: 156.2px;
//           }
//           &--note-taking {
//             width: 182.3px;
//             height: 156.2px;
//           }
//           &--start {
//             width: 164px;
//             height: 164px;
//           }
//         }
//         &__text {
//           font-family: Nunito Sans;
//           font-size: 20.72px;
//           text-align: center;
//           margin-top: 19px;
//           color: #7776be;
//         }
//       }
//     }
//   }
//   .space-start-recording {
//     padding: 14px 10px 24px 10px;
//     background-color: #f0f0ff;
//     .recording-button {
//       width: 100%;
//       display: flex;
//       background-color: #ffffff;
//       height: 43px;
//       padding: 10px 20px 10px 20px;
//       border-radius: 20px;
//       box-sizing: border-box;
//       text-align: center;
//       border: none;
//       cursor: pointer;
//       outline: none;
//       justify-content: center;
//       align-items: center;
//       &__text {
//         font-family: Nunito Sans;
//         font-size: 17px;
//         color: #36369b;
//       }
//       &__icon {
//         font-size: 16px;
//         opacity: 0.35;
//         color: #36369b;
//         margin-left: 10px;
//         &--pause {
//           margin-left: 0px;
//         }
//       }
//       &__circle {
//         width: 7px;
//         height: 7px;
//         border-radius: 50%;
//         border: 7px solid #ff453a;
//         margin-left: 10px;
//       }
//       &--pause {
//         width: 43px;
//         margin-right: 10px;
//         box-shadow: 0px 0px 8.35px 0px #bcbcffa3;
//         border-radius: 50%;
//       }
//       &--finish {
//         background-color: rgb(224, 230, 237);
//         color: rgb(138, 147, 157);
//         font-family: Nunito;
//         font-size: 20.28px;
//         font-family: Nunito Sans Bold;
//         line-height: 18px;
//         &--active {
//           background-color: #00a600;
//           color: #ffffff;
//         }
//       }
//       &--continue {
//         margin-right: 10px;
//       }
//     }
//     .active-recording-buttons {
//       display: flex;
//       width: 100%;
//       justify-content: space-between;
//     }
//     .button-recording {
//     }
//   }
// `;

import styled from "styled-components";

export const TransducerGoogleChirp1 = styled.div`
  height: 100%;
  box-sizing: border-box;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 100%;

  .transducer-content {
    height: calc(100% - 81px);
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .transducer-choose-type {
      height: 100%;
      display: flex;

      .transductor-mode {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        &__label {
          font-family: Nunito Sans Bold;
          font-size: 20px;
          margin-bottom: 10px;
        }
        &__selected {
          width: 100%;
          display: flex;
          justify-content: center;
        }
      }

      .message-space {
        /* [CORRECCIÓN] Cambiado de calc a flex 1 para evitar que el contenido se suba */
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;

        &__title {
          font-family: Nunito Sans Bold;
          font-size: 20px;
          margin-bottom: 40px;
        }

        &__img {
          &--medical-consultation {
            width: 424.6px;
            height: 156.2px;
          }
          &--note-taking {
            width: 182.3px;
            height: 156.2px;
          }
          &--start {
            width: 164px;
            height: 164px;
          }
        }

        &__text {
          font-family: Nunito Sans;
          font-size: 20.72px;
          text-align: center;
          margin-top: 19px;
          color: #7776be;
          padding: 0 20px;
        }
      }
    }
  }

  .space-start-recording {
    padding: 14px 10px 24px 10px;
    background-color: #f0f0ff;

    /* [NUEVO] Botones Duales (Cargar + Start) */
    .dual-action-buttons {
      display: flex;
      gap: 12px;
      width: 100%;

      .btn-upload-audio {
        flex: 1;
        height: 43px;
        background-color: #ffffff;
        border-radius: 20px;
        padding: 10px 20px;
        color: #36369b;
        font-family: Nunito Sans;
        font-size: 17px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &__icon {
          font-size: 14px;
          opacity: 0.8;
        }
      }

      .recording-button {
        flex: 1.4; /* El botón de Start es ligeramente más ancho */
      }
    }

    .recording-button {
      width: 100%;
      display: flex;
      background-color: #ffffff;
      height: 43px;
      padding: 10px 20px;
      border-radius: 20px;
      box-sizing: border-box;
      text-align: center;
      border: none;
      cursor: pointer;
      outline: none;
      justify-content: center;
      align-items: center;
      transition: all 0.2s ease;

      &__text {
        font-family: Nunito Sans;
        font-size: 17px;
        color: #36369b;
      }

      &__icon {
        font-size: 16px;
        opacity: 0.35;
        color: #36369b;
        margin-left: 10px;
        &--pause {
          margin-left: 0px;
        }
      }

      &__circle {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        border: 7px solid #ff453a;
        margin-left: 10px;
      }

      &--pause {
        width: 43px;
        margin-right: 10px;
        box-shadow: 0px 0px 8.35px 0px #bcbcffa3;
        border-radius: 50%;
      }

      &--finish {
        background-color: rgb(224, 230, 237);
        color: rgb(138, 147, 157);
        font-family: Nunito Sans Bold;
        font-size: 20.28px;
        line-height: 18px;
        &--active {
          background-color: #00a600;
          color: #ffffff;
        }
      }

      &--continue {
        margin-right: 10px;
      }
    }

    .active-recording-buttons {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  }
`;

/* [NUEVO] Contenedor del Modal de Carga */
export const ModalUploadWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;

  .modal-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .modal-body {
    position: relative;
    background: white;
    width: 360px;
    padding: 35px 25px;
    border-radius: 24px;
    text-align: center;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);

    &__icon {
      font-size: 45px;
      color: #36369b;
      margin-bottom: 20px;
      display: block;
    }

    &__text {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #444;
      margin-bottom: 30px;
      line-height: 1.5;
    }

    &__actions {
      display: flex;
      gap: 12px;

      .btn-base {
        flex: 1;
        padding: 12px;
        border-radius: 12px;
        border: none;
        font-family: Nunito Sans Bold;
        font-size: 15px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
      }

      .btn--cancel {
        background-color: #f2f2f5;
        color: #777;
        &:hover {
          background-color: #ebebef;
        }
      }

      .btn--primary {
        background-color: #36369b;
        color: white;
        &:hover {
          background-color: #2a2a7a;
        }
      }
    }
  }
`;
